<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <DialogJSONError ref="dlgError"></DialogJSONError>
    <v-toolbar app color="#fdfdfd" flat height="60px" id="myToolbar" style="z-index: 2">
        <v-card color="transparent" flat v-if="!isLogin" class="pt-2 hidden-xs-only" to="/Dashboard"
                style="position: fixed; top: 10px; width: 100%;"
        >
          <img :src="'./static/' + logoExtImage"
               height="30px"
               width="auto"
          >
        </v-card>
      <v-card color="transparent" flat v-if="!isLogin" class="pt-2 hidden-sm-and-up" to="/Dashboard"
              style="position: fixed; top: 15px; width: 75%;"
      >
        <img :src="'./static/eValueRate_Logo2.png'"
             height="20px"
             width="auto"
        >
      </v-card>

      <v-menu top offset-y v-if="!isLogin" style="z-index:10000000000000000000; position: absolute;"
              v-model="menuVisible">

        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" small>
            <v-icon color="#004884">menu</v-icon>
          </v-btn>
        </template>
        <v-card width="250" color="white" flat>
          <v-card color="blue" class="body-2 pa-1 font-weight-bold white--text">
            {{'ACCOUNT_TITLE_LOGIN' | translate}}: {{foreName}} {{lastName}}
          </v-card>
          <v-divider></v-divider>
          <v-layout justify-start style="background-color: white">
            <!--
            :active.sync="active" return-object v-model="tree" @change="openMenuItem" :items="items" :active="active" :open="open" open-on-click activatable
            -->

            <v-treeview :active.sync="activeTreeModel" :open="open" open-on-click v-model="tree" :items="items"
                        @change="openMenuItem" return-object>
              <template v-slot:label="{ item, open }">
                <span style="float:left;" class="body-1 TextNav"
                      @click="openMenuItem(item)">{{item.name | translate}}</span>
              </template>
            </v-treeview>
          </v-layout>

          <v-card-actions style="background-color: white">
            <v-btn to="/Logout" color="blue" dark small block class="font-weight-bold text-none">
              {{'BUTT_LOGOUT' | translate}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <BtnBack  v-if="!isDashboard && !hideCauseLogin" class="hidden-xs-only"></BtnBack>
      <v-card color="transparent" flat v-if="showRegister" class="marginlogo toolbarIE pt-2" to="/Dashboard">
        <img :src="'./static/eValueRate_Logo2.png'"
             height="25px"
             width="auto"
        >
      </v-card>

      <v-card flat>
        <!--<v-card-text class="bluetext pl-2 caption pb-2" v-if="!isLogin">
          {{idModule}}
        </v-card-text>-->
      </v-card>

      <v-spacer></v-spacer>

      <v-card flat v-if="!isLogin" z-index="9000000">
        <v-btn
            color="primary"
            dark
            flat
            icon
            round
            v-on="on"
            to="/di/DownloadCenter"
            >
            <v-icon large>
              file_download
            </v-icon>
        </v-btn>
      </v-card>
      <div class="px-1 hidden-sm-and-down">
        <v-menu open-on-click top offset-y v-if="!isLogin" z-index="9000000">
          <template v-slot:activator="{ on }">
            <!--<v-btn small fab flat outline @click="showMenu" v-on="on" color="#004884">
              <v-icon medium>person</v-icon>
            </v-btn>-->
            <v-avatar size=40 color="transparent" v-on="on" class="pointer" @click="showMenu">
              <v-icon color="#004884">person</v-icon>
            </v-avatar>
          </template>
          <v-card width="200px">
            <v-card>
              <v-card color="blue" class="body-2 pa-1 font-weight-bold white--text">
                {{'ACCOUNT_TITLE_LOGIN' | translate}}: {{foreName}} {{lastName}}
              </v-card>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in itemsAvatar"
                  :key="index"
                  @click="openMenuItem(item)"
                  class="body-2 bluetext"
                >
                  <v-list-tile-title class="body-2 bluetext">
                    <v-icon color="#004884">{{ item.icon}}</v-icon>
                    {{ item.title | translate}}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-card>
        </v-menu>
      </div>
      <div class="mr-5">
        <v-btn depressed :color="getLangColor('de')" :class="getLangClass('de')" flat fab small class="mx-0"
               @click="setLocale('de')">DE
        </v-btn>
        <v-btn depressed :color="getLangColor('en')" :class="getLangClass('en')" flat fab small class="mx-0"
               @click="setLocale('en')">EN
        </v-btn>
      </div>
      <btnSupport></btnSupport>
    </v-toolbar>
   <!-- <v-container>
      <v-flex xs12>
        <v-card class="bluetext caption text-xs-center justify-center hidden-xs-only" v-if="!isLogin" style="z-index: 300;background-color: red">
          {{idModule}}
        </v-card>
      </v-flex>
    </v-container> -->
  </div>
</template>

<script>
import Vue from 'vue'
import BtnBack from './widgets/BtnBack'
import btnSupport from './widgets/BtnSupport'
import DialogJSONError from '@/components/dialogs/DialogJSONError'
import $ from 'jquery'

export default {
  name: 'Toolbar.vue',
  components: {BtnBack, btnSupport, DialogJSONError},
  data () {
    return {
      language: 'de',
      headerFields: [{'id': 'companyName', 'type': 'nm', 'orderNr': '0', 'name': 'Name des Unternehmens'}, {
        'id': 'rk',
        'type': 'nm',
        'orderNr': '1',
        'name': 'Rechtskreis'
      }, {'id': 'aa', 'type': 'nm', 'orderNr': '2', 'name': 'Abschlussart'}, {
        'id': 'year',
        'type': 'nm',
        'orderNr': '4',
        'name': 'Jahr'
      }, {
        'id': 'source',
        'type': 'nm',
        'orderNr': '5',
        'name': 'Quelle'
      }],
      isLogin: true,
      logoExtImage: '',
      isDashboard: true,
      idModule: 'Unternehmen',
      loading: false,
      select: null,
      itemsresults: [],
      results: [],
      tree: [],
      active: [],
      isCRS: Vue.prototype.$config.IS_CRS,
      open: [1],
      showBackBtn: false,
      menuVisible: false,
      onb: false,
      on: false,
      on2: false,
      foreName: '',
      lastName: '',
      hideCauseLogin: false,
      activeTreeModel: [],
      crumps: [],
      itemsAvatar: [],
      items: [],
      myMenu: false,
      showRegister: false
    }
  },
  watch: {
    on (val) {
      this.on = val
      if (!this.on) {
        Vue.prototype.$eventHub.$emit('OnShowIdle', false)
      }
    },
    activeTree (val) {
      this.active = val
      Vue.prototype.$api.debug('activeTree', val)
      if (val.length > 0) {
        this.openMenuItem(val[0])
      }
    }
  },
  methods: {
    doFilterAC: function(item, queryText, itemText) {
      // console.log('doFilterAC', item, queryText, itemText)
      // itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      return true
    },
    setLocale: function (language) {
      var languageId = 1
      Vue.prototype.$config.language = language
      if (language === 'de') {
        languageId = 1
      } else if (language === 'en') {
        languageId = 2
      }
      Vue.prototype.$config.languageId = languageId
      this.language = language
      Vue.i18n.set(language)

      Vue.prototype.$api.getI18NFromServer(function () {
        Vue.prototype.$api.debug('setlocale', Vue.prototype.$config.languageId)
        Vue.prototype.$eventHub.$emit('setLocale', Vue.prototype.$config.languageId)
        Vue.prototype.$eventHub.$emit('setLocale2', Vue.prototype.$config.languageId)
      })
    },
    getLangColor: function (lan) {
      if (lan === this.language) {
        return ''
      } else {
        return ''
      }
    },
    showError: function (data) {
      Vue.prototype.$api.debug('showError', data)
      Vue.prototype.$api.hideIdle()

      if (data && data.xhr) {
        const contentType = data.xhr.getResponseHeader("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          var j = JSON.parse(data.xhr.responseText);
          if (j.exception === 'SqlFormulaException') {
            this.$refs.dlgError.open({
              newName: '',
              title: Vue.i18n.translate('TITLE_ERROR_FORMULA'),
              type: '',
              description: j.text,
              details: j.details,
            });
            return;
          }
          if (j.exception === 'UserException') {
            this.$refs.dlgError.open({
              newName: '',
              title: j.title,
              type: '',
              description: j.text,
              details: j.details,
            });
            return;
          }
          this.$refs.dlgError.open({
            newName: 'Servererror',
            title: 'Servererror',
            type: '',
            description: j.exception + ": " + j.text,
            details: ["File: " + j.file + " Line: " + j.line, "Details:", j.details, "Backtrace:", j.backtrace].join("\n")
          });
        }
        else {
          if (data.xhr.status == 403) {
            this.$refs.dlgError.open({
              newName: Vue.i18n.translate('JSON_FAILED_TITLE'),
              title: Vue.i18n.translate('JSON_FAILED_TITLE'),
              type: '',
              description: Vue.i18n.translate('JSON_FAILED_DESCRIPTION')
            });
          }
          else {
            this.$refs.dlgError.open({
              newName: 'Servererror',
              title: 'Servererror: ' + data.xhr.status,
              type: '',
              description: data.xhr.statusText
            });
          }
        }
      }
      else if (data && data.isDetail) {
        this.$refs.dlgError.open({
          newName: data.title,
          title: data.title,
          type: '',
          description: data.message
        })
      } else {
        let s = ""
        if (data.status) {
          s = data.status
        }
        let errorMsg = ""
        if (errorMsg) {
          errorMsg = data.errorMsg
        }
        this.$refs.dlgError.open({
          newName: Vue.i18n.translate('JSON_FAILED_TITLE'),
          title: Vue.i18n.translate('JSON_FAILED_TITLE') + ' ' + s,
          type: '',
          description: Vue.i18n.translate('JSON_FAILED_DESCRIPTION') + errorMsg
        })
      }
    },
    getLangClass: function (lan) {
      if (lan === this.language) {
        return 'countrySelected'
      } else {
        return 'countryDefault'
      }
    },

    OnShowRegister: function (d) {
      this.showRegister = d
    },
    OnShowLogin: function (show) {
      this.hideCauseLogin = show
    },
    onClick: function () {
      window.history.back()
    },
    showMenu () {
      // Vue.prototype.$eventHub.$emit('OnShowIdle', true)
    },
    OnSetLocale () {
      this.OnGetModuleTitle('')
    },
    OnGetModuleTitle (title) {
      this.showBackBtn = title !== ''
      var t = ''
      if (Vue.prototype.$api.getModuleId() != null) {
        t = Vue.i18n.translate(Vue.prototype.$api.getModuleId().toUpperCase() + '_TITLE')
        this.logoExtImage = 'eValueRate_Logo_Module_' + Vue.prototype.$api.getModuleId().toLowerCase()
      } else {
        this.logoExtImage = 'eValueRate_Logo_Module'
      }
      if (Vue.prototype.$api.getLanguage() === 2) {
        this.logoExtImage = this.logoExtImage + '_en'
      }
      this.logoExtImage = this.logoExtImage + '.png'

      this.idModule = t + ' ' + title
    },
    onGetBreadcrumb (data) {
      // console.log('onGetBreadcrumb', data)
      this.isDashboard = !data || data.length <= 1
      this.crumps = data
    },
    openMenuItem (item) {
      Vue.prototype.$api.debug('item', item)
      if (item.link) {
        this.$router.push(item.link)
        // this.$router.push('/di/' + item.link + '/' + this.idModule)
        //this.$router.push(item.link + '/' + this.idModule)
        // this.$router.push('/di/Module/' + 'companies')
        return
      }
      if (item.id === '0') {
        this.$router.push('/Dashboard')
      } else if (item.id === '22') {
        this.$router.push('/di/Newsbox')
      } else if (item.id === '997') {
        this.$router.push('/di/UserSettings')
      } else if (item.id === '998') {
        this.$router.push('/ResetPassword')
      } else if (item.id === '999') {

        Vue.prototype.$eventHub.$emit('OnGetModuleTitle', '')
        Vue.prototype.$eventHub.$emit('OnLogin', true)
        this.$router.push('/Logout')
      }
    },
    OnLogin (ok) {
      this.isLogin = !ok
      if (ok) {
        this.foreName = Vue.prototype.$api.getCredentials().data.user.firstName
        this.lastName = Vue.prototype.$api.getCredentials().data.user.lastName
      } else {
        return
      }
      this.updateMenu()
    },
    updateMenu () {
      this.menuVisible = false
      this.itemsAvatar = []
      this.items = []
      this.items.push({
        id: '0',
        name: 'MENU_DASHBOARD'
      })
      this.moduleList = Vue.prototype.$api.getModuleList()
      for (var i in this.moduleList) {
        var module = this.moduleList[i]
        if (module.privateDB || module.publicDB) {
          this.items.push({
            id: module.id,
            name: module.id.toUpperCase() + '_TITLE',
            link: '/di/Module/' + module.id
            //this.$router.push('/di/' + item.link + '/' + this.idModule)
          })
        }
      }

      //this.items = this.items.concat([{
       // id: '22',
       // name: 'MENU_NEWSBOX'
      //}
      //])

      if (Vue.prototype.$api.isAdmin()) {
        this.items = this.items.concat([
          {
            id: '42',
            link: '/di/Administration',
            name: 'MENU_ADMINISTRATION'
          }
        ])
      }

      this.items = this.items.concat([
        {
          id: '997',
          link: '/di/UserSettings',
          name: 'MENU_USER_SETTINGS'
        }
      ]);
      this.items = this.items.concat([
        {
          id: '998',
          name: 'MENU_CHANGE_PASSWORD'
        }
      ])

      this.itemsAvatar.push(
        {
          id: '997',
          icon: 'settings',
          title: 'MENU_USER_SETTINGS'
        }
      )
      this.itemsAvatar.push(
        {
          id: '998',
          icon: 'build',
          title: 'MENU_CHANGE_PASSWORD'
        }
      )
      this.itemsAvatar.push(
        {
          id: '999',
          icon: 'power_settings_new',
          title: 'BUTT_LOGOUT'
        }
      )
    },
    onHit () {
      Vue.prototype.$api.debug('smenu', this.$refs)
      this.myMenu = true
    },
    onLogout () {
      this.loging = true
      Vue.prototype.$eventHub.$emit('OnGetBreadcrumb', [])
    }
  },
  created () {
    Vue.prototype.$eventHub.$on('OnLogin', this.OnLogin)
    Vue.prototype.$eventHub.$on('OnShowError', this.showError)
    Vue.prototype.$eventHub.$on('OnLogout', this.onLogout)
    Vue.prototype.$eventHub.$on('OnShowLogin', this.OnShowLogin)
    Vue.prototype.$eventHub.$on('OnShowRegister', this.OnShowRegister)
    Vue.prototype.$eventHub.$on('OnGetBreadcrumb', this.onGetBreadcrumb)
    Vue.prototype.$eventHub.$on('OnGetModuleTitle', this.OnGetModuleTitle)
    Vue.prototype.$eventHub.$on('setLocale', this.OnSetLocale)
  },
  destroyed () {
    Vue.prototype.$eventHub.$off('OnLogin', this.OnLogin)
    Vue.prototype.$eventHub.$off('OnShowError', this.showError)
    Vue.prototype.$eventHub.$off('OnShowLogin', this.OnShowLogin)
    Vue.prototype.$eventHub.$off('OnShowRegister', this.OnShowRegister)
    Vue.prototype.$eventHub.$off('OnLogout', this.onLogout)
    Vue.prototype.$eventHub.$off('OnGetBreadcrumb', this.onGetBreadcrumb)
    Vue.prototype.$eventHub.$off('OnGetModuleTitle', this.OnGetModuleTitle)
    Vue.prototype.$eventHub.$off('setLocale', this.OnSetLocale)
  },

  mounted () {
    var cmp = this
    Vue.prototype.$api.checkCredentials(this)
    this.menuVisible = false
    this.on = false
    this.language = Vue.prototype.$config.language
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue